<script>
  export let topGenres = [];
  export let hideVotes = false;

  function convertToPercentage(value, total = 17316) {
    return ((value / total) * 100).toFixed(2);
  }
</script>

<ul class="list-group">
  {#each topGenres as genre}
    <li class="list-item">
      <span>
        <h2>{genre.key}</h2>
        {#if !hideVotes}
          <p>
            <!-- {genre.doc_count} vote{genre.doc_count > 1 ? 's' : ''} -->
            {convertToPercentage(genre.doc_count)}% of votes
          </p>
        {/if}
      </span>
    </li>
  {/each}
</ul>

<style>
  .list-group {
    list-style: none;
    padding: 0;
  }

  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 8px 16px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .list-image {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }

  p,
  h2 {
    margin: 0;
    /* padding: 0; */
  }

  h2 {
    font-size: 1.3rem;
    margin-bottom: 8px;
  }
</style>
